export default __webpack_public_path__ + "static/media/zoho.953bde82.svg";